import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
mode: 'abstract', // abstract
base: process.env.BASE_URL,
	routes: [
		{
			path: "/",
			redirect: "/index",
        },
		{
			path: "/index",
			component: resolve => require(['@/views/index'],resolve),
			name: "首页"
		},
		{
			path: "/panorama",
			component: resolve => require(['@/views/panorama'],resolve),
			name: "全景"
		},
		{
			path: "/list",
			component: resolve => require(['@/views/list'],resolve),
			name: "列表"
		},
		{
			path: "/map",
			component: resolve => require(['@/views/map'],resolve),
			name: "地图"
        },
        {
			path: "/routerPage",
			component: resolve => require(['@/views/routerPage'],resolve),
			name: "路线"
        },
        {
			path: "/supplierAllBack",
			component: resolve => require(['@/views/supplierAllBack'],resolve),
			name: "空白页"
        }
	]
})
